import { ElMessage } from 'element-plus';

const DEFAULT_THROTTLE_MS = 2000;
const lastShownAt = new Map();

function normalizeMessage(message) {
  if (typeof message === 'string') return message.trim();
  if (message == null) return '';
  return String(message);
}

function buildDedupeKey(type, message, dedupeKey) {
  return dedupeKey ?? `${type}:${normalizeMessage(message)}`;
}

function isThrottled(key, throttleMs) {
  const now = Date.now();
  const last = lastShownAt.get(key) ?? 0;
  if (now - last < throttleMs) return true;
  lastShownAt.set(key, now);
  return false;
}

function show(type, input, options = {}) {
  let messageText;
  let rest;

  if (typeof input === 'string') {
    messageText = input;
    rest = options;
  } else if (input && typeof input === 'object') {
    messageText = input.message ?? '';
    rest = { ...input, ...options };
    delete rest.message;
  } else {
    messageText = normalizeMessage(input);
    rest = options;
  }

  const {
    throttleMs = DEFAULT_THROTTLE_MS,
    dedupeKey,
    skipDedupe = false,
    grouping = false,
    ...elOptions
  } = rest;

  const msg = normalizeMessage(messageText);
  if (!msg) return;

  if (!skipDedupe) {
    const key = buildDedupeKey(type, msg, dedupeKey);
    if (isThrottled(key, throttleMs)) return;
  }

  return ElMessage({
    type,
    message: msg,
    grouping,
    ...elOptions,
  });
}

const message = {
  success: (input, options) => show('success', input, options),
  error: (input, options) => show('error', input, options),
  warning: (input, options) => show('warning', input, options),
  info: (input, options) => show('info', input, options),
  closeAll: (...args) => ElMessage.closeAll(...args),
};

export default message;
